import { render, staticRenderFns } from "./AddressMap.vue?vue&type=template&id=2d70a566&"
import script from "./AddressMap.vue?vue&type=script&lang=js&"
export * from "./AddressMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports